(() => {
  const ensurePredictiveStyles = () => {
    if (document.getElementById('mxp-smart-search-styles')) return;
    const style = document.createElement('style');
    style.id = 'mxp-smart-search-styles';
    style.textContent = `
      [data-mps-search-form]{position:relative}
      [data-mps-search-results]{overflow:hidden!important;border:1px solid #e4e6e9!important;border-radius:16px!important;background:#fff!important;box-shadow:0 18px 44px rgba(17,18,22,.14)!important}
      [data-mps-search-results] .predictive__group{margin:0!important;padding:8px!important}
      [data-mps-search-results] .predictive__heading{display:flex!important;align-items:center!important;justify-content:space-between!important;margin:0!important;padding:9px 10px 7px!important;color:#737983!important;font-size:10px!important;font-weight:900!important;letter-spacing:.10em!important;text-transform:uppercase!important}
      [data-mps-search-results] .predictive__list{display:grid!important;gap:2px!important}
      [data-mps-search-results] .predictive__item{display:grid!important;grid-template-columns:58px minmax(0,1fr) auto!important;align-items:center!important;gap:12px!important;min-height:70px!important;margin:0!important;padding:7px 9px!important;border-radius:12px!important;color:#111216!important;text-decoration:none!important;transition:background .12s ease!important}
      [data-mps-search-results] .predictive__item:hover,[data-mps-search-results] .predictive__item.is-active{background:#f6f7f8!important;color:#111216!important}
      [data-mps-search-results] .predictive__media{width:58px!important;height:58px!important;display:grid!important;place-items:center!important;overflow:hidden!important;border:1px solid #eceef1!important;border-radius:11px!important;background:#fff!important}
      [data-mps-search-results] .predictive__media img{width:100%!important;height:100%!important;padding:4px!important;border-radius:0!important;object-fit:contain!important}
      [data-mps-search-results] .predictive__copy{min-width:0!important;display:grid!important;gap:4px!important}
      [data-mps-search-results] .predictive__title{overflow:hidden!important;text-overflow:ellipsis!important;white-space:nowrap!important;color:#111216!important;font-size:13.5px!important;font-weight:850!important;line-height:1.25!important}
      [data-mps-search-results] .predictive__meta{color:#7b818a!important;font-size:10px!important;font-weight:650!important}
      [data-mps-search-results] .predictive__price{padding-left:8px!important;color:#111216!important;font-size:12px!important;font-weight:900!important;white-space:nowrap!important}
      [data-mps-search-results] .predictive__empty{padding:20px 14px!important;text-align:center!important;color:#747a83!important;font-size:12px!important}
      [data-mps-search-results] .mxp-search-loading{display:flex!important;align-items:center!important;gap:9px!important;padding:18px!important;color:#747a83!important;font-size:12px!important}
      [data-mps-search-results] .mxp-search-loading:before{content:"";width:16px;height:16px;border:2px solid #e2e4e7;border-top-color:#ffc400;border-radius:50%;animation:mxpSearchSpin .65s linear infinite}
      @keyframes mxpSearchSpin{to{transform:rotate(360deg)}}
      @media(max-width:749px){
        #MobileNav [data-mps-search-results]{left:0!important;right:0!important;top:calc(100% + 7px)!important;max-height:58vh!important;overflow-y:auto!important;border-radius:14px!important}
        #MobileNav [data-mps-search-results] .predictive__group{padding:6px!important}
        #MobileNav [data-mps-search-results] .predictive__item{grid-template-columns:54px minmax(0,1fr) auto!important;min-height:66px!important;padding:6px 7px!important}
        #MobileNav [data-mps-search-results] .predictive__media{width:54px!important;height:54px!important}
        #MobileNav [data-mps-search-results] .predictive__title{font-size:13px!important}
        #MobileNav [data-mps-search-results] .predictive__price{font-size:11.5px!important}
      }
    `;
    document.head.appendChild(style);
  };

  const init = (root = document) => {
    ensurePredictiveStyles();
    root.querySelectorAll('[data-mps-search-form]').forEach((form) => {
      if (form.dataset.mpsSearchReady === 'true') return;
      form.dataset.mpsSearchReady = 'true';

      const input = form.querySelector('[data-mps-search-input]');
      const results = form.querySelector('[data-mps-search-results]');
      const endpoint = form.dataset.predictiveUrl;
      if (!input || !results || !endpoint) return;

      let debounceTimer;
      let controller;
      let activeIndex = -1;
      let loadingTimer;
      const cache = new Map();

      const normalize = (raw) => {
        const original = String(raw || '').trim().replace(/\s+/g, ' ');
        const lower = original.toLocaleLowerCase('fr-FR');
        if (['ip','iph','ipho','iphon','i phone'].includes(lower)) return 'iphone';
        const ipModel = lower.match(/^ip(?:hone)?\s*[- ]?\s*(\d.*)$/);
        if (ipModel) return 'iphone ' + ipModel[1].trim();
        if (['sam','sams','samsu','samsun'].includes(lower)) return 'samsung';
        if (['mac','macb','macbo','macboo'].includes(lower)) return 'macbook';
        return original;
      };

      const close = () => {
        results.hidden = true;
        results.innerHTML = '';
        activeIndex = -1;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
      };

      const open = () => {
        if (!results.innerHTML.trim()) return;
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      };

      const items = () => Array.from(results.querySelectorAll('a.predictive__item'));

      const setActive = (next) => {
        const links = items();
        if (!links.length) return;
        activeIndex = (next + links.length) % links.length;
        links.forEach((link, index) => {
          const active = index === activeIndex;
          link.classList.toggle('is-active', active);
          link.setAttribute('aria-selected', active ? 'true' : 'false');
          if (!link.id) link.id = 'mxp-search-result-' + index;
        });
        input.setAttribute('aria-activedescendant', links[activeIndex].id);
        links[activeIndex].scrollIntoView({ block: 'nearest' });
      };

      const keepPreviewContext = () => {
        let current;
        try { current = new URL(window.location.href); } catch (_) { return; }
        results.querySelectorAll('a[href]').forEach((link) => {
          try {
            const target = new URL(link.getAttribute('href'), window.location.origin);
            ['preview_theme_id','preview_key','pb'].forEach((key) => {
              if (current.searchParams.has(key) && !target.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
            });
            link.setAttribute('href', target.pathname + target.search + target.hash);
          } catch (_) {}
        });
      };

      const renderHtml = (html) => {
        results.innerHTML = html;
        activeIndex = -1;
        keepPreviewContext();
        open();
      };

      const load = async (rawTerm) => {
        const term = normalize(rawTerm);
        if (!term) return;
        const cacheKey = term.toLocaleLowerCase('fr-FR');
        if (cache.has(cacheKey)) {
          renderHtml(cache.get(cacheKey));
          return;
        }
        if (controller) controller.abort();
        controller = new AbortController();
        clearTimeout(loadingTimer);
        loadingTimer = window.setTimeout(() => {
          results.innerHTML = '<div class="mxp-search-loading">Recherche des produits…</div>';
          open();
        }, 140);

        const params = new URLSearchParams({
          q: term,
          'resources[type]': 'product',
          'resources[limit]': '10',
          section_id: 'predictive-search'
        });

        try {
          const response = await fetch(`${endpoint}?${params.toString()}`, {
            signal: controller.signal,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            credentials: 'same-origin'
          });
          if (!response.ok) throw new Error('Predictive search failed');
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('[data-predictive-inner]');
          clearTimeout(loadingTimer);
          if (!inner || !inner.innerHTML.trim()) {
            renderHtml('<div class="predictive__empty">Aucun produit trouvé.</div>');
            return;
          }
          const content = inner.innerHTML;
          cache.set(cacheKey, content);
          renderHtml(content);
        } catch (error) {
          clearTimeout(loadingTimer);
          if (error.name !== 'AbortError') renderHtml('<div class="predictive__empty">Recherche momentanément indisponible.</div>');
        }
      };

      input.addEventListener('input', () => {
        clearTimeout(debounceTimer);
        const term = input.value.trim();
        if (term.length < 2) {
          if (controller) controller.abort();
          if (!term && document.activeElement === input) debounceTimer = window.setTimeout(() => load('iphone'), 80);
          else close();
          return;
        }
        debounceTimer = window.setTimeout(() => load(term), 115);
      });

      input.addEventListener('focus', () => {
        if (results.innerHTML.trim()) open();
        else if (!input.value.trim()) load('iphone');
        else if (input.value.trim().length >= 2) load(input.value);
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          close();
          input.blur();
          return;
        }
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          if (results.hidden && input.value.trim().length >= 2) load(input.value);
          else setActive(activeIndex + 1);
          return;
        }
        if (event.key === 'ArrowUp') {
          event.preventDefault();
          setActive(activeIndex <= 0 ? items().length - 1 : activeIndex - 1);
          return;
        }
        if (event.key === 'Enter' && activeIndex >= 0) {
          const links = items();
          if (links[activeIndex]) {
            event.preventDefault();
            links[activeIndex].click();
          }
        }
      });

      document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) close();
      });
    });
  };

  const ensureServiceCardStyles = () => {
    if (document.getElementById('mpsv3-device-card-enhancements')) return;

    const style = document.createElement('style');
    style.id = 'mpsv3-device-card-enhancements';
    style.textContent = `
      .mpsv3 .mpsv3__device-types {
        display: grid !important;
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
        gap: 18px !important;
        margin-top: 28px !important;
      }

      .mpsv3 .mpsv3__device-types .mpsv3__device-card {
        position: relative;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: flex-end !important;
        gap: 0 !important;
        min-height: 330px !important;
        padding: 22px 20px 25px !important;
        border: 1.5px solid #e1e4e8 !important;
        border-radius: 24px !important;
        background: linear-gradient(180deg, #ffffff 0%, #fbfbfc 100%) !important;
        box-shadow: 0 10px 30px rgba(17, 18, 22, .06) !important;
        color: #111216 !important;
        overflow: hidden !important;
        text-align: center !important;
        cursor: pointer !important;
        transition: transform .22s ease, box-shadow .22s ease, border-color .22s ease, background .22s ease !important;
      }

      .mpsv3 .mpsv3__device-types .mpsv3__device-card::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: inherit;
        pointer-events: none;
        background: radial-gradient(circle at 50% 30%, rgba(255,196,0,.11), transparent 43%);
        opacity: 0;
        transition: opacity .22s ease;
      }

      .mpsv3 .mpsv3__device-types .mpsv3__device-card:hover,
      .mpsv3 .mpsv3__device-types .mpsv3__device-card:focus-visible {
        transform: translateY(-5px) !important;
        border-color: #ffc400 !important;
        background: linear-gradient(180deg, #fffef8 0%, #fff9df 100%) !important;
        box-shadow: 0 20px 46px rgba(17, 18, 22, .12) !important;
        outline: none !important;
      }

      .mpsv3 .mpsv3__device-types .mpsv3__device-card:hover::before,
      .mpsv3 .mpsv3__device-types .mpsv3__device-card:focus-visible::before {
        opacity: 1;
      }

      .mpsv3 .mpsv3__device-visual {
        position: relative;
        z-index: 1;
        display: grid;
        place-items: center;
        width: 100%;
        height: 230px;
        margin: 0 0 8px;
      }

      .mpsv3 .mpsv3__device-image {
        display: block;
        width: 100%;
        height: 100%;
        max-width: 360px;
        object-fit: contain;
        mix-blend-mode: multiply;
        transform: scale(.96);
        transition: transform .22s ease;
      }

      .mpsv3 .mpsv3__device-card[data-category='iphone'] .mpsv3__device-image,
      .mpsv3 .mpsv3__device-card[data-category='samsung'] .mpsv3__device-image {
        max-width: 245px;
      }

      .mpsv3 .mpsv3__device-card[data-category='macbook'] .mpsv3__device-image {
        max-width: 390px;
      }

      .mpsv3 .mpsv3__device-card:hover .mpsv3__device-image,
      .mpsv3 .mpsv3__device-card:focus-visible .mpsv3__device-image {
        transform: scale(1.02);
      }

      .mpsv3 .mpsv3__device-title {
        position: relative;
        z-index: 1;
        display: block !important;
        margin: 0 !important;
        font-size: clamp(21px, 1.7vw, 27px) !important;
        line-height: 1.05 !important;
        font-weight: 950 !important;
        letter-spacing: -.03em !important;
        color: #111216 !important;
      }

      @media (max-width: 900px) {
        .mpsv3 .mpsv3__device-types {
          gap: 12px !important;
        }

        .mpsv3 .mpsv3__device-types .mpsv3__device-card {
          min-height: 285px !important;
          padding: 18px 14px 22px !important;
          border-radius: 20px !important;
        }

        .mpsv3 .mpsv3__device-visual {
          height: 195px;
        }
      }

      @media (max-width: 749px) {
        .mpsv3 .mpsv3__device-types {
          grid-template-columns: 1fr !important;
          gap: 13px !important;
          margin-top: 20px !important;
        }

        .mpsv3 .mpsv3__device-types .mpsv3__device-card {
          min-height: 245px !important;
          padding: 15px 18px 20px !important;
          border-radius: 20px !important;
          box-shadow: 0 8px 24px rgba(17, 18, 22, .07) !important;
        }

        .mpsv3 .mpsv3__device-visual {
          height: 180px;
          margin-bottom: 3px;
        }

        .mpsv3 .mpsv3__device-card[data-category='iphone'] .mpsv3__device-image,
        .mpsv3 .mpsv3__device-card[data-category='samsung'] .mpsv3__device-image {
          max-width: 205px;
        }

        .mpsv3 .mpsv3__device-card[data-category='macbook'] .mpsv3__device-image {
          max-width: 330px;
        }

        .mpsv3 .mpsv3__device-title {
          font-size: 23px !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const enhanceServiceCards = (root = document) => {
    root.querySelectorAll('.mpsv3__device-types').forEach((grid) => {
      if (grid.dataset.mpsDeviceCardsEnhanced === 'true') return;
      grid.dataset.mpsDeviceCardsEnhanced = 'true';

      grid.innerHTML = `
        <button type="button" class="mpsv3__device-card" data-category="iphone" aria-label="iPhone">
          <span class="mpsv3__device-visual" aria-hidden="true">
            <img class="mpsv3__device-image" src="https://cdn.shopify.com/s/files/1/0965/3977/1212/files/maxpromo-reprise-iphone.jpg?v=1787840350&width=700" srcset="https://cdn.shopify.com/s/files/1/0965/3977/1212/files/maxpromo-reprise-iphone.jpg?v=1787840350&width=320 320w, https://cdn.shopify.com/s/files/1/0965/3977/1212/files/maxpromo-reprise-iphone.jpg?v=1787840350&width=520 520w, https://cdn.shopify.com/s/files/1/0965/3977/1212/files/maxpromo-reprise-iphone.jpg?v=1787840350&width=700 700w" sizes="(min-width: 901px) 28vw, (min-width: 750px) 30vw, 88vw" width="520" height="310" loading="lazy" alt="">
          </span>
          <span class="mpsv3__device-title">iPhone</span>
        </button>
        <button type="button" class="mpsv3__device-card" data-category="samsung" aria-label="Samsung Galaxy">
          <span class="mpsv3__device-visual" aria-hidden="true">
            <img class="mpsv3__device-image" src="https://cdn.shopify.com/s/files/1/0965/3977/1212/files/maxpromo-reprise-samsung.jpg?v=1787840366&width=700" srcset="https://cdn.shopify.com/s/files/1/0965/3977/1212/files/maxpromo-reprise-samsung.jpg?v=1787840366&width=320 320w, https://cdn.shopify.com/s/files/1/0965/3977/1212/files/maxpromo-reprise-samsung.jpg?v=1787840366&width=520 520w, https://cdn.shopify.com/s/files/1/0965/3977/1212/files/maxpromo-reprise-samsung.jpg?v=1787840366&width=700 700w" sizes="(min-width: 901px) 28vw, (min-width: 750px) 30vw, 88vw" width="520" height="310" loading="lazy" alt="">
          </span>
          <span class="mpsv3__device-title">Samsung Galaxy</span>
        </button>
        <button type="button" class="mpsv3__device-card" data-category="macbook" aria-label="MacBook">
          <span class="mpsv3__device-visual" aria-hidden="true">
            <img class="mpsv3__device-image" src="https://cdn.shopify.com/s/files/1/0965/3977/1212/files/maxpromo-reprise-macbook.jpg?v=1787840415&width=700" srcset="https://cdn.shopify.com/s/files/1/0965/3977/1212/files/maxpromo-reprise-macbook.jpg?v=1787840415&width=320 320w, https://cdn.shopify.com/s/files/1/0965/3977/1212/files/maxpromo-reprise-macbook.jpg?v=1787840415&width=520 520w, https://cdn.shopify.com/s/files/1/0965/3977/1212/files/maxpromo-reprise-macbook.jpg?v=1787840415&width=700 700w" sizes="(min-width: 901px) 28vw, (min-width: 750px) 30vw, 88vw" width="520" height="310" loading="lazy" alt="">
          </span>
          <span class="mpsv3__device-title">MacBook</span>
        </button>
      `;
    });
  };

  const initDirectAccount = () => {
    if (window.__mpsDirectAccountReady) return;
    window.__mpsDirectAccountReady = true;

    document.addEventListener('click', (event) => {
      const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      const accountComponent = path.find((node) => node && node.tagName && node.tagName.toLowerCase() === 'shopify-account');
      if (!accountComponent) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign('/account');
    }, true);
  };

  const initAll = (root = document) => {
    init(root);
    ensureServiceCardStyles();
    enhanceServiceCards(root);
    initDirectAccount();
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
